// The floor plan's limits and shapes, shared by the console and the server (spec/13 §3.4, F-ORG-03).
//
// "Validation is the same on the server" (spec/13 §3.4): the console's arrange mode and
// `PUT …/floor-plan` refuse the same plans with the same messages. The limits are here, in the
// contract, so both read one number; the rules that use them are `floorPlanProblems` in
// `@clavian/domain`, which both run.
import { z } from "../zod.js";
/** "Grid of up to 60 columns × 100 rows" (spec/13 §3.4). */
export const FLOOR_MAX_COLUMNS = 60;
export const FLOOR_MAX_ROWS = 100;
/** "Zones (name, colour token, rectangle, up to 30 per floor)" (spec/13 §3.4, F-ORG-03 rule 2). */
export const MAX_ZONES_PER_FLOOR = 30;
/** "Fixtures (…; resize, label; up to 100)" (spec/13 §3.4). Read as per floor, like zones. */
export const MAX_FIXTURES_PER_FLOOR = 100;
/**
 * The floors (levels) a venue may have. Several floors are P1 (spec/13 §3.4); the numbers are
 * accepted now so that a zone created today does not need migrating, and ten levels is more than any
 * venue in the brief. Ground is 0.
 */
export const FLOOR_MIN = 0;
export const FLOOR_MAX = 9;
export const FloorNumberSchema = z
    .int()
    .min(FLOOR_MIN)
    .max(FLOOR_MAX)
    .openapi('FloorNumber', { description: 'Which level of the venue: 0 is the ground floor.', example: 0 });
/** spec/13 §3.4's fixtures. */
export const FIXTURE_KINDS = [
    'counter',
    'entrance',
    'lounge',
    'wall',
    'pillar',
    'screen',
    'window',
    'restroom',
    'stairs',
];
export const FixtureKindSchema = z.enum(FIXTURE_KINDS).openapi('FixtureKind');
/**
 * A rectangle on the grid, in whole cells from the top-left corner: column `x`, row `y`, `w` wide and
 * `h` tall. A shape to spread into an item's object rather than a schema to nest or intersect, so
 * the generated clients see four plain fields.
 */
export const gridRectShape = {
    x: z.int().min(0).max(FLOOR_MAX_COLUMNS - 1),
    y: z.int().min(0).max(FLOOR_MAX_ROWS - 1),
    w: z.int().min(1).max(FLOOR_MAX_COLUMNS),
    h: z.int().min(1).max(FLOOR_MAX_ROWS),
};
//# sourceMappingURL=floor.js.map